export var TransferOrderItemStatus;
(function (TransferOrderItemStatus) {
    TransferOrderItemStatus[TransferOrderItemStatus["ENTERED"] = 1] = "ENTERED";
    TransferOrderItemStatus[TransferOrderItemStatus["PICKING"] = 2] = "PICKING";
    TransferOrderItemStatus[TransferOrderItemStatus["PARTIAL"] = 3] = "PARTIAL";
    TransferOrderItemStatus[TransferOrderItemStatus["FULFILLED"] = 4] = "FULFILLED";
    TransferOrderItemStatus[TransferOrderItemStatus["SHORT"] = 5] = "SHORT";
    TransferOrderItemStatus[TransferOrderItemStatus["VOID"] = 6] = "VOID";
})(TransferOrderItemStatus || (TransferOrderItemStatus = {}));
//# sourceMappingURL=transfer-order-item-status.js.map